import { render, staticRenderFns } from "./vehicleDetail.vue?vue&type=template&id=1f44b71d&scoped=true&"
import script from "./vehicleDetail.vue?vue&type=script&lang=js&"
export * from "./vehicleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f44b71d",
  null
  
)

export default component.exports